export const scrollTo = (id) => {
  const element = document.getElementById(id);
  if (element) {
    const y = element.getBoundingClientRect().top + window.scrollY - 80; // 80px offset for the sticky header
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};